/* eslint-disable import/first */
/* eslint no-param-reassign: "off", no-console: "off" */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import SystemStore from './system/system-store';
import UserStore from './user/user-store';
import RemoteStore from './remotes/remote-store';
import JobsStore from './jobs/jobs-store';
import StorageStore from './shared/file-storage/storage-store';
import ApiStore from './api/api-store';
import AdminStore from './admin/admin-store';
import ZonesStore from './zones/zones-store';
import DashboardStore from './dashboard/dashboard-store';
import AccountStore from './accounts/accounts-store';
import DevicesStore from './devices/device-store';
import SearchStore from './search/search-store';
import SubscriptionsStore from './subscriptions/subscription-store';
import SupportStore from './support/support-store';
import ConfiguratorStore from './configurator/configurator-store';
import GroupsStore from './groups/group-store';
// Fetch intercepts are registered before the first fetch from the store occurs
import RegisterFetchIntercepts from '../platform/fetchIntercept'
import dataPersistencePlugin from '../platform/dataPersistencePlugin';

export default function Store(config, router) {
  const store = new Vuex.Store({
    state: {
      appLoaded: false,
      appConfig: config,
      appHealth: null,
      maintenanceMode: false,
      appStatus: null
    },
    mutations: {
      setAppIsLoaded(state, payload) {
        state.appLoaded = payload;
      },
      setAppHealth(state, payload) {
        state.appHealth = payload;
      },
      setMaintenanceModeFlag(state, payload) {
        state.maintenanceMode = payload;
      },
      setAppStatus(state, payload) {
        state.appStatus = payload;
      }
    },
    actions: {
      async fetchAppHealth({ commit }) {
        try {
          // get maintenance mode flag to show the maintenance mode banned in the Top Bar
          // the request invokes the middleware in the API to check the config value for MaintenanceMode
          const maintenanceResponse = await fetch('/health/maintenance');
          // extract the response header
          const maintenanceFlag = maintenanceResponse.headers.get('maintenancemode');
          if (maintenanceFlag && maintenanceFlag == 'true') {
            // set app state to indicate maintenance mode is ON
            commit('setMaintenanceModeFlag', true);
          }

          // fetch general app health
          const healthResponse = await fetch('/health');
          if (!healthResponse.ok) return false;
          commit('setAppHealth', await healthResponse.text());
          return true;
        } catch (ex) {
          return false;
        }
      },
      async fetchAppStatus({ commit }) {
        try {
          // fetch general app health
          const statusResponse = await fetch('/status');
          if (!statusResponse.ok) return false;
          commit('setAppStatus', await statusResponse.json());
        } catch (ex) {
          console.error(ex);
        } finally {
          // eslint-disable-next-line no-unsafe-finally
          return true;
        }
      }
    },
    modules: {
      system: SystemStore,
      user: UserStore,
      remotes: RemoteStore,
      jobs: JobsStore,
      storage: StorageStore,
      admin: AdminStore,
      zones: ZonesStore,
      dashboard: DashboardStore,
      accounts: AccountStore,
      devices: DevicesStore,
      search: SearchStore,
      api: ApiStore,
      subscriptions: SubscriptionsStore,
      support: SupportStore,
      configurator: ConfiguratorStore,
      groups: GroupsStore
    },
    plugins: [dataPersistencePlugin]
  });
  RegisterFetchIntercepts(config, router, store);
  return store;
}
